export default "__VITE_ASSET__jFl1DWZm__"